import { render } from "./switch-table.vue?vue&type=template&id=1e7a33a5&scoped=true&ts=true"
import script from "./switch-table.vue?vue&type=script&lang=ts"
export * from "./switch-table.vue?vue&type=script&lang=ts"

import "./switch-table.vue?vue&type=style&index=0&id=1e7a33a5&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7a33a5"]])

export default __exports__